<template>
  <div class="elevation-3 ma-3 pa-3">
    <v-row>
      <v-col cols="1" class="mt-2"/>
      <v-col cols="10" class="pt-0 pb-0">
        <CommonDropDowns :isItTaxYearWithoutAllYears=true
        @change="dataFromCommonDropDowns" />
        <v-select :items="getMappersItems" class="input-text-size mt-n4"
        item-text="name" item-value="name" label="Select Profile/Company"
        @change="onDropDownChange"/>
        <!-- The remote folder is derived from the first word of the profile above
             (Lereta -> /LERETA/BILLREQUEST, CoreLogic -> /CL/BILLREQUEST), so this
             picker stays empty until a profile is chosen. -->
        <v-select :items="ftpFiles" class="input-text-size mt-n4"
        item-text="label" item-value="name" label="Select FTP File"
        v-model="selectedFtpFile"
        :loading="loadingFtpFiles"
        :disabled="!selectedProfileName || loadingFtpFiles"
        clearable/>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0 mt-n11">
          <CommonImportFiles @loadCRUDList="loadBillRequestAfterImport"
          :dynamicUpdateInputs="dynamicUpdateInputsValues"
          :fileResolver="resolveFtpFile" />
      </v-col>
      <v-col cols="12" class="pt-2 pb-0 mt-n5">
        <v-row>
          <v-col cols="6" class="pt-2 pb-0">
            <label class="input-text-size">Total Records in File :</label>
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0"
            :value="totalResults.totalRecords" readonly hide-details />
          </v-col>
          <v-col cols="6" class="pt-2 pb-0">
            <label class="input-text-size">Matches :</label>
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0" :value="totalResults.matches"
            readonly hide-details />
          </v-col>
          <v-col cols="6" class="pt-2 pb-0">
            <label class="input-text-size">Mis-matched: </label>
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0" readonly
            :value="totalResults.errors" hide-details />
          </v-col>
          <v-col cols="6" class="pt-2 pb-0">
            <label class="input-text-size">Records with Mtg code: </label>
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0" readonly
            :value="totalResults.recordsWithMtgCode" hide-details />
          </v-col>
        </v-row>
      </v-col>
    <v-row>
      <v-col cols="6">
        <v-checkbox class="input-text-size radio-and-checekbox-size" v-model="checkboxForMismatch"
        label="Show mis-matched Only" @change="loadBillRequestAfterImport" />
      </v-col>
      <v-col cols="6">
        <v-checkbox class="input-text-size radio-and-checekbox-size"
        v-model="checkboxForMismatchAndRecWithMtgCode"
        label="Show mis-matched and records with mtg code only"
        @change="loadBillRequestAfterImport" />
      </v-col>
      <v-col class="mt-n10 pt-0 d-flex justify-center">
        <v-btn class="input-text-size" text color="blue darken-1" @click="printErrorList">
          Print Error List
        </v-btn>
      </v-col>
    </v-row>
    </v-row>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import CommonImportFiles from '../../common/import/CommonImportFiles.vue';
import { transformMapperListFields } from '../../../util/shared/transform';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import '../../../assets/style.css';

const { backendRest } = clients.direct;

// The backend hands the file back as base64 so the bytes survive the trip - these
// are fixed-width / delimited files where an ascii round-trip could shift a column.
// Rebuilt into a File here so it is indistinguishable from a local pick downstream.
const base64ToFile = (base64, fileName) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], fileName, { type: 'text/plain' });
};

export default {
  name: 'MtgCoBillRequestsSideBar',
  components: {
    CommonImportFiles,
    CommonDropDowns,
  },
  data() {
    return {
      checkboxForMismatch: false,
      checkboxForMismatchAndRecWithMtgCode: false,
      baseCrudKeyForMappers: 'mtg-bill-request-mapper-list',
      dynamicUpdateInputsValues: { type: 'constant', prop: 'mtgCompanyTaxYear', value: 0 },
      selectedProfileName: '',
      ftpFiles: [],
      selectedFtpFile: null,
      loadingFtpFiles: false,
    };
  },
  created() {
    this.loadMappers();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapState({
      mortgageCoMapperItems: (state) => state.tax.MortgageCoProcessing.mortgageCompanyMapperItems,
      totalResults: (state) => state.tax.MortgageCoProcessing.totalResults,
    }),
    getMappersItems() {
      const itemData = this.items(this.baseCrudKeyForMappers);
      return itemData;
    },
  },
  methods: {
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    ...mapMutations('tax/MortgageCoProcessing', [
      'setPipeline',
    ]),
    ...mapActions(['reAuth', 'flashError']),
    dataFromCommonDropDowns(val) {
      this.dynamicUpdateInputsValues = { type: 'constant', prop: 'mtgCompanyTaxYear', value: val };
    },
    loadMappers() {
      if (!this.getMappersItems.length) {
        this.loadTransformMappers({
          criteria: { type: 'import', program: 'MTGBILLREQUESTS' },
          fields: { ...transformMapperListFields },
          baseCrudKey: this.baseCrudKeyForMappers,
        });
      }
    },
    onDropDownChange(val) {
      const itemData = this.getMappersItems;
      const [filtTaxData] = itemData.filter((ft) => ft.name === val);
      this.setPipeline(filtTaxData || {});
      this.selectedProfileName = val || '';
      this.loadFtpFiles();
    },
    async loadFtpFiles() {
      // Changing the profile changes the remote folder, so anything already picked
      // belongs to the old one and is dropped.
      this.ftpFiles = [];
      this.selectedFtpFile = null;
      if (!this.selectedProfileName) return;
      this.loadingFtpFiles = true;
      try {
        await this.reAuth();
        const response = await backendRest.get('/mortgage/bill-request/ftp/files', {
          params: { profileName: this.selectedProfileName },
        });
        this.ftpFiles = Array.isArray(response.data) ? response.data : [];
      } catch (err) {
        console.error('Error loading bill request FTP files', err);
        this.flashError('Unable to read the bill request file list from the FTP server.');
      } finally {
        this.loadingFtpFiles = false;
      }
    },
    // Handed to CommonImportFiles and called only when Import is clicked with no
    // local file chosen. Selecting from the picker records a name and nothing more -
    // the file is fetched at import time, so browsing the list costs no transfers.
    async resolveFtpFile() {
      const fileName = this.selectedFtpFile;
      if (!fileName) return null;
      try {
        await this.reAuth();
        const response = await backendRest.get('/mortgage/bill-request/ftp/file', {
          params: { profileName: this.selectedProfileName, fileName },
        });
        const { base64 } = response.data || {};
        if (!base64) throw new Error('empty response');
        return base64ToFile(base64, fileName);
      } catch (err) {
        console.error('Error reading bill request FTP file', err);
        this.flashError(`Unable to read "${fileName}" from the FTP server.`);
        return null;
      }
    },
    loadBillRequestAfterImport() {
      this.$emit('loadCRUDList', this.checkboxForMismatch, this.checkboxForMismatchAndRecWithMtgCode);
    },
    async printErrorList() {
      const params = await this.getParamsData();
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/mortgageCoProcessing/printErrorList${queryString}`;
      window.open(url, '_blank');
    },
    async getParamsData() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const params = [];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      params.push(`token=${jwt}`);
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      params.push(`filters=${encodedCriteria}`);
      return params;
    },
  },
};
</script>
